import React from 'react';
import { string, shape, func } from 'prop-types';


export default function LocationTile({ item, handleOpenModal, viewMoreText }) {
    return (
        <button type="button" onClick={() => handleOpenModal(item, 'location')} className="c-base-tile c-listing-tile c-location-tile">
            <div className="tile-content" >
                <div className="tile-thumbnail" style={{ backgroundImage: `url(${item.thumbnail})` }} />
                <div className="title">{item.title}</div>
            </div>
            <div className="view-more">{viewMoreText}</div>

        </button>
    );
}

LocationTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        thumbnail: string,
        title: string.isRequired
    }).isRequired,
    viewMoreText: string.isRequired,
    handleOpenModal: func.isRequired
    /* eslint-enable react/no-typos */
};
